import React, { useState } from "react";
import styled from "styled-components";
import { useTranslate } from '@tolgee/react';

const MoodIconsBar = ({ moods, selectedMood, onMoodSelect, getMoodIcon, getMoodLabel }) => {
  const [hoveredMood, setHoveredMood] = useState(null);
  const { t } = useTranslate();

  return (
    <MoodContainer>
      <MoodRow>
        {moods.map((mood, index) => (
          <MoodIconWrapper
            key={mood}
            onMouseEnter={() => setHoveredMood(mood)}
            onMouseLeave={() => setHoveredMood(null)}
          >
            <MoodIconButton
              active={selectedMood === mood}
              onClick={() => onMoodSelect(mood)}
            >
              {getMoodIcon(mood)}
            </MoodIconButton>
            {hoveredMood === mood && (
              <Tooltip 
                position={
                  index === 0 ? 'left' : 
                  index === moods.length - 1 ? 'right' : 
                  'center'
                }
              >
                <TooltipText>{t('call_modal.translation_style')}: {getMoodLabel(mood)}</TooltipText>
                <TooltipArrow position={
                  index === 0 ? 'left' : 
                  index === moods.length - 1 ? 'right' : 
                  'center'
                } />
              </Tooltip>
            )}
          </MoodIconWrapper>
        ))}
      </MoodRow>
    </MoodContainer>
  );
};

export default MoodIconsBar;

const MoodContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const MoodRow = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
`;

const MoodIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MoodIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: ${({ active, theme }) => active ? theme.primaryButton.borderColor : theme.callComponent.participantComponentBackground};
  border: 2px solid ${({ active, theme }) => active ? theme.primaryButton.borderColor : 'transparent'};
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 24px;
    height: 24px;
    fill: ${({ active, theme }) => active ? '#ffffff' : theme.moodIcon.color};
  }

  &:hover {
    background: ${({ active, theme }) => active ? theme.primaryButton.borderColor : theme.moodIcon.backgroundSelected};
    border-color: ${({ theme }) => theme.primaryButton.borderColor};
    transform: translateY(-2px);

    svg {
      fill: ${({ theme }) => theme.moodIcon.colorSelected};
    }
  }
`;

const Tooltip = styled.div`
  position: absolute;
  bottom: -42px;
  ${({ position }) => {
    if (position === 'left') return 'left: 0;';
    if (position === 'right') return 'right: 0;';
    return 'left: 50%; transform: translateX(-50%);';
  }}
  padding: 8px 14px;
  background: ${({ theme }) => theme.callComponent.participantComponentBackground};
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 10;
  pointer-events: none;
`;

const TooltipText = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  white-space: nowrap;
`;

const TooltipArrow = styled.div`
  position: absolute;
  top: -4px;
  ${({ position }) => {
    if (position === 'left') return 'left: 16px;';
    if (position === 'right') return 'right: 16px;';
    return 'left: 50%; transform: translateX(-50%);';
  }}
  width: 8px;
  height: 8px;
  background: ${({ theme }) => theme.callComponent.participantComponentBackground};
  transform: ${({ position }) => 
    position === 'center' ? 'translateX(-50%) rotate(45deg)' : 'rotate(45deg)'
  };
`;